module.exports = __webpack_public_path__ + "img/welcome.cf70c1ca.png";